<template>
  <div class="h5-page">
    <div class="h5-header">
      <span class="back" @click="$router.back()">返回</span>
      <span class="title">添加{{ platformName }}账号</span>
      <span class="right"></span>
    </div>

    <div class="h5-wrap">
      <img v-if="!isXyb" class="logo" src="./assets/img/logo.png" alt="公学芸" />
      <div v-else class="platform-name">校友邦</div>

      <div class="form">
        <div class="field">
          <label>账号</label>
          <input v-model="form.phone" type="text" placeholder="账号/手机号" :disabled="loading" />
        </div>
        <div class="field">
          <label>密码</label>
          <input v-model="form.password" type="password" placeholder="密码" :disabled="loading" />
        </div>
        <div v-if="!isXyb" class="field province-field">
          <label>打卡省份</label>
          <select ref="provinceSelect" v-model="form.province" :disabled="loading" aria-label="打卡省份">
            <option value="" disabled>请选择打卡省份</option>
            <option v-for="province in provinces" :key="province" :value="province">{{ province }}</option>
          </select>
        </div>
        <button class="primary" :disabled="loading" @click="onSubmit">{{ waitingForProxy ? '正在获取网络...' : (loading ? '处理中...' : '登录并添加') }}</button>
        <p v-if="waitingForProxy" class="proxy-wait-message" role="status">正在获取网络，请保持页面打开，稍后会自动继续。</p>
      </div>

      <div class="notice" v-if="notice"><span>{{ noticeParts.before }}</span><span class="notice-promo">{{ noticeParts.promo }}</span><span>{{ noticeParts.after }}</span></div>

      <div class="links">
        <a v-if="!isXyb" href="https://kdocs.cn/l/ctyHOlcQP9MP" target="_blank">使用教程</a>
        <a @click.prevent="showQQ">联系客服</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Toast } from 'vant'
import { API_ENDPOINTS, TIMEOUT_CONFIG } from '@/config/api'
import GXY_PROVINCES from '@/config/gxyProvinces'
import { createAccountProxyOperation, waitForAccountProxy } from '@/utils/accountProxyWait'

const DEFAULT_SITE_NOTICE = [
  '1. 自定义签到位置',
  '2. 自动签到',
  '3. 每个用户独立的 IP 和云手机',
  '4. ChatGPT（AI）撰写日报/周报/月报，内容真实不重样',
  '半年卡限时 39 元',
  '充值100积分送44积分'
].join('\n')

export default {
  computed: {
    isXyb() {
      return this.$route.query.platform === 'xyb'
    },
    platformName() {
      return this.isXyb ? '校友邦' : '公学芸'
    },
    noticeParts() {
      const text = this.notice || ''
      const promo = '半年卡限时 39 元'
      const idx = text.indexOf(promo)
      if (idx < 0) return { before: text, promo: '', after: '' }
      return {
        before: text.slice(0, idx),
        promo: promo,
        after: text.slice(idx + promo.length)
      }
    }
  },
  data() {
    return {
      form: { phone: '', password: '', province: '' },
      provinces: [...GXY_PROVINCES].sort((a, b) => a.localeCompare(b, 'zh-Hans-CN')),
      loading: false,
      waitingForProxy: false,
      accountProxyOperation: null,
      notice: '',
      logoUrl: API_ENDPOINTS.STATIC.GXY_LOGO
    }
  },
  mounted() {
    window.addEventListener('pagehide', this.stopAccountProxyWaiting)
    this.form.phone = String(this.$route.query.phone || '')
    if (!this.isXyb) this.fetchNotice()
  },
  beforeRouteLeave(to, from, next) {
    this.stopAccountProxyWaiting()
    next()
  },
  beforeDestroy() {
    this.stopAccountProxyWaiting()
    window.removeEventListener('pagehide', this.stopAccountProxyWaiting)
  },
  methods: {
    stopAccountProxyWaiting() {
      if (!this.accountProxyOperation) return
      this.accountProxyOperation = null
      this.waitingForProxy = false
      this.loading = false
    },
    promptProvinceSelection() {
      this.form.province = ''
      Toast('请选择打卡省份后再提交')
      this.$nextTick(() => {
        const select = this.$refs.provinceSelect
        if (select) select.focus()
      })
    },
    async onSubmit() {
      if (this.loading) return
      if (!this.form.phone || !this.form.password) {
        Toast('请输入账号和密码')
        return
      }
      if (!this.isXyb && !this.form.province) {
        this.promptProvinceSelection()
        return
      }
      const isXyb = this.isXyb
      let operation = null
      try {
        const token = localStorage.getItem('token')
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu')
          return
        }
        this.loading = true
        const endpoint = isXyb ? API_ENDPOINTS.XYB.ADD_USER : API_ENDPOINTS.GXY.ADD_USER
        const payload = {
          phone: this.form.phone,
          password: this.form.password
        }
        let res
        if (isXyb) {
          res = await axios.post(endpoint, payload, { headers: { Authorization: `Bearer ${token}` } })
        } else {
          payload.province = this.form.province
          operation = createAccountProxyOperation()
          this.accountProxyOperation = operation
          res = await waitForAccountProxy(op => axios.post(endpoint, {
            ...payload, operation_id: op.id, operation_step: op.step
          }, { headers: { Authorization: `Bearer ${token}` }, timeout: TIMEOUT_CONFIG.GXY_ADD_ACCOUNT }), operation, {
            isCurrent: () => this.accountProxyOperation === operation,
            onWait: () => { this.waitingForProxy = true }
          })
          if (!res || this.accountProxyOperation !== operation) return
          this.waitingForProxy = false
        }
        if (!isXyb && res.data && Number(res.data.code) === 20003) {
          this.promptProvinceSelection()
          return
        }
        if (res.data && res.data.code === 0) {
          Toast.success(res.data.message || '添加成功')
          this.$router.push(isXyb ? '/lanhu_zhanghaoguanli?tab=xyb' : '/lanhu_zhanghaoguanli')
        } else {
          Toast.fail(res.data.message || '绑定失败')
        }
      } catch (e) {
        if (operation && this.accountProxyOperation !== operation) return
        if (!isXyb && e.response && e.response.data && Number(e.response.data.code) === 20003) {
          this.promptProvinceSelection()
          return
        }
        const serverMsg = e.response && e.response.data && e.response.data.message
        if (serverMsg) {
          Toast.fail(serverMsg)
        } else if (e.response && e.response.status === 401) {
          Toast.fail('登录已过期，请重新登录')
        } else {
          Toast.fail(isXyb ? '网络错误，请刷新页面后重试' : '连接中断，添加结果暂未确认，请先查看账号列表')
        }
      } finally {
        if (!operation || this.accountProxyOperation === operation) {
          this.accountProxyOperation = null
          this.waitingForProxy = false
          this.loading = false
        }
      }
    },
    async fetchNotice() {
      try {
        const res = await axios.get(API_ENDPOINTS.SETTING.GET_SETTING, { params: { key: 'site_notice' } })
        if (res.data && res.data.code === 0 && res.data.data) {
          this.notice = res.data.data
        } else {
          this.notice = DEFAULT_SITE_NOTICE
        }
      } catch (e) {
        this.notice = DEFAULT_SITE_NOTICE
      }
    },
    async showQQ() {
      try {
        const res = await axios.post(API_ENDPOINTS.SETTING.GET_SETTING, { key: 'qq' })
        const qq = (res.data && res.data.code === 0 && res.data.data) ? res.data.data : '3842705664'
        Toast('客服联系方式QQ：' + String(qq))
      } catch (e) {
        Toast('客服联系方式QQ：3842705664')
      }
    }
  }
}
</script>

<style scoped>
/* 页面基础 */
.h5-page { background: #f7f7f7; min-height: 100vh; }
.h5-header { position: sticky; top: 0; z-index: 10; height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0 12px; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,.06); }
.h5-header .back { color: #1989fa; font-size: 14px; }
.h5-header .title { font-weight: 600; font-size: 16px; }

/* 内容容器：375px 设计宽，H5 居中 */
.h5-wrap { box-sizing: border-box; width: 100%; max-width: 560px; margin: 0 auto; padding: 16px; }
.logo { width: 50px; height: 50px; display: block; margin: 24px auto; }
.platform-name { margin: 24px auto; text-align: center; color: #202124; font-size: 24px; font-weight: 600; }

.form { box-sizing: border-box; width: 100%; background: #fff; border-radius: 8px; padding: 16px; box-shadow: 0 2px 8px rgba(0,0,0,.04); }
.field { display: flex; align-items: center; border: 1px solid #eee; border-radius: 8px; padding: 10px 12px; margin-bottom: 12px; background: #fafafa; }
.field label { width: 48px; color: #666; font-size: 14px; }
.field input { flex: 1; border: none; outline: none; background: transparent; font-size: 14px; }
.province-field label { width: 72px; flex-shrink: 0; }
.province-field select { flex: 1; min-width: 0; border: none; outline: none; background: transparent; color: #202124; font-size: 14px; }

.primary { width: 100%; height: 40px; border: none; border-radius: 20px; background: #07c160; color: #fff; font-size: 15px; }
.primary:disabled { opacity: .7; }
.proxy-wait-message { margin: 12px 0 0; color: #666; font-size: 13px; line-height: 1.6; }

.notice { margin: 16px 0; padding: 10px 12px; color: #E6A23C; background: #fff; border-radius: 8px; font-size: 12px; line-height: 1.6; white-space: pre-line; }
.notice-promo { color: #ff3b30; font-weight: 700; font-size: 14px; }
.links { text-align: center; margin-top: 8px; }
.links a { font-size: 14px; color: #1989fa; margin: 0 10px; }
</style>
